@import '../../global/variables/grid';

:host {
  .lgr-card-highlighted {
    display: flex;
    flex-direction: row;
    height: 224px;
    max-height: 224px;
    overflow: hidden;
    border-radius: var(--lgr-border-radius-lg);
    border: 1px solid var(--lgr-color-neutral-high-medium);
    background: var(--lgr-color-neutral-high-pure);

    .image-wrapper {
      width: 112px;
      min-width: 112px;
      height: 50%;
      border-bottom-right-radius: 28px;
      overflow: hidden;

      ::slotted(img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }

    .text-button-wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      padding: var(--lgr-spacing-xxxs);

      .text-wrapper {
        display: flex;
        flex-direction: column;
        gap: var(--lgr-spacing-xxxs);

        [name="title"] {
          font-family: var(--lgr-font-family-bold);
          font-size: var(--lgr-font-size-md);
          line-height: var(--lgr-spacing-xxs);
          color: var(--lgr-color-neutral-low-dark);
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          max-height: 3em;
        }

        [name="authors"] {
          font-family: var(--lgr-font-family-regular);
          font-size: var(--lgr-font-size-xs);
          line-height: var(--lgr-spacing-xxxs);
        }
      }
    }

    @media (min-width: $lgr-grid-md-break-point) {
      background: transparent;

      .image-wrapper,
      .text-button-wrapper {
        width: 50%;
      }

      .image-wrapper {
        height: 100%;
        max-width: unset;
        border-bottom-right-radius: 76px;
      }

      &-short {
        .image-wrapper {
          height: 50%;
          width: 112px;
          min-width: 112px;
          border-bottom-right-radius: 28px;
        }
      }
    }
  }
}